import React from 'react';
import VolumeRetrieveEditForm from './VolumeRetrieveEditForm';
import SetTitle from '../../utils/set_title';
import { FilterDataProvider } from '../../HOC/volumeReportFiltersContext';
import Header from '../../components/Headers/Header'

const VolumeRetrieveEdit = () => {
SetTitle('Edit Market Screener');
return (
    <FilterDataProvider>
        <Header
            iconClass="ni ni-time-alarm text-white"
            title="Edit Market Screener Report"
            docLink="/docs/ranking_tools/market-screener/"
        >
            <VolumeRetrieveEditForm />
        </Header>
    </FilterDataProvider>
)

}

export default VolumeRetrieveEdit